<div class="chat-page">

  <!-- Header -->
  <header class="chat-header">
    <div class="header-left">
      <div class="brand-icon">
        <i class="bi bi-robot"></i>
      </div>

      <div class="brand-info">
        <h1>Assetto AI</h1>
        <span>AI Assistant</span>
      </div>
    </div>

    <div class="header-actions">
      <button class="header-btn" mat-icon-button matTooltip="New Chat" (click)="newChat()">
        <i class="bi bi-plus-lg"></i>
      </button>

      <button class="header-btn" mat-icon-button matTooltip="Close" routerLink="/admin">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </header>


  <!-- Chat Content -->
  <main class="chat-main">

    <!-- Empty / Welcome State -->
    <div class="welcome-section" *ngIf="currentMessages.length === 0">

      <div class="welcome-icon">
        <i class="bi bi-stars"></i>
      </div>

      <h2>How can I help you?</h2>

      <p>
        Ask Assetto AI about assets, devices, network information,
        reports, monitoring and more.
      </p>

      <!-- Suggestions -->
      <div class="suggestions">
        <button
          class="suggestion-chip"
          *ngFor="let suggestion of suggestions"
          (click)="useSuggestion(suggestion)"
        >
          <i class="bi bi-arrow-right"></i>
          {{ suggestion }}
        </button>
      </div>

    </div>


    <!-- Messages -->
    <div
      class="chat-messages"
      #chatContainer
      *ngIf="currentMessages.length > 0"
    >

      <div
        class="message-wrapper"
        *ngFor="let msg of currentMessages"
        [ngClass]="msg.role"
      >

        <!-- Avatar -->
        <div class="message-avatar">

          <div
            class="msg-avatar assistant-avatar"
            *ngIf="msg.role === 'assistant'"
          >
            <i class="bi bi-robot"></i>
          </div>

          <div
            class="msg-avatar user-avatar"
            *ngIf="msg.role === 'user'"
          >
            <i class="bi bi-person"></i>
          </div>

        </div>


        <!-- Message -->
        <div class="message-content">

          <div class="message-name">
            {{ msg.role === 'assistant' ? 'Assetto AI' : 'You' }}
          </div>

          <div class="message-bubble">
            <p>{{ msg.content }}</p>
          </div>

        </div>

      </div>

    </div>

  </main>


  <!-- Bottom Input Area -->
  <footer class="chat-input-area">

    <!-- Suggestions when conversation has started -->
    <div
      class="suggestions suggestions-bottom"
      *ngIf="currentMessages.length > 0 && currentMessages.length <= 1"
    >
      <button
        class="suggestion-chip"
        *ngFor="let suggestion of suggestions"
        (click)="useSuggestion(suggestion)"
      >
        {{ suggestion }}
      </button>
    </div>


    <!-- Input -->
    <div class="input-container">

      <div class="input-wrapper">
        <textarea
          #messageInput
          [(ngModel)]="userInput"
          placeholder="Send a message to Assetto AI..."
          rows="1"
          (keydown)="handleKeyDown($event)"
        ></textarea>

        <div class="input-actions">
          <div class="input-actions-left">
            <button
              class="attach-btn"
              matTooltip="Attach file"
              (click)="fileInput.click()"
            >
              <i class="bi bi-paperclip"></i>
            </button>
            <input 
              type="file" 
              #fileInput 
              (change)="onFileSelected($event)" 
              style="display: none;" 
              multiple
            >
          </div>

          <div class="input-actions-right">
            <button
              class="send-btn"
              [disabled]="!userInput?.trim()"
              (click)="sendMessage()"
              matTooltip="Send message"
            >
              <i class="bi bi-send-fill"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="input-footer">

        <span class="disclaimer">
          Assetto AI can make mistakes. Consider verifying important information.
        </span>

        <span class="shortcut">
          <kbd>Enter</kbd>
          <span>to send</span>
        </span>

      </div>

    </div>

  </footer>

</div>